'use strict';

angular.module('atex.art').controller('ArtContentListCtrl',
['$scope', '$rootScope', '$location', '$timeout', 'ArtConfirmModal', 'ArtConflictModal', 'ArtErrorModal', 'ArtContentStore', 'ArtTemplateStore',

 'ArtSynchronizationService', 'ArtPrintData', 'ArtListOptions', 'ArtLockingService', 'ArtInboxOptions', 'articles', 'templates', '$translate', 'valdr', 'PageTitle','$window', 'ArtCommonServices', 'ApplicationConfigurationService',
'UserProfileService',
  function($scope, $rootScope, $location, $timeout, ArtConfirmModal, ArtConflictModal, ArtErrorModal, ArtContentStore, ArtTemplateStore,
           ArtSynchronizationService, ArtPrintData, ArtListOptions, ArtLockingService, ArtInboxOptions, articles, templates, $translate, valdr, PageTitle, $window, ArtCommonServices, ApplicationConfigurationService,
           UserProfileService) {

	  $scope.locale = $translate.use();
    $scope.articles = articles;

    // Always clear any possible edit chain
    delete $rootScope.editChain;

    $scope.syncInProgress = false;
    $scope.listOptions = ArtListOptions.listOptions;
    $scope.showHeadlineInList = undefined;
    $scope.showStatusInList = undefined;
    $scope.titleLabel = "TITLE";
    $scope.allowedInputTemplates = undefined;

    ApplicationConfigurationService.getConfigurationFor(['showHeadlineInList'], false).then(function(showHeadlineInListValue){
      $scope.showHeadlineInList = showHeadlineInListValue;
    });

    ApplicationConfigurationService.getConfigurationFor(['titleLabel'], 'TITLE').then(function(titleLabelValue){
      if (titleLabelValue !== undefined){
        $scope.titleLabel = titleLabelValue;
      }
    });

    ApplicationConfigurationService.getConfigurationFor(['showStatusInList'], false).then(function(showStatusInListValue){
      $scope.showStatusInList = showStatusInListValue;
    });

    ApplicationConfigurationService.getConfigurationFor(['allowedInputTemplates'], undefined).then(function(allowedInputTemplatesValue){
      if (allowedInputTemplatesValue !== undefined){
        $scope.allowedInputTemplates = allowedInputTemplatesValue;
      }
    });

    $rootScope.PageTitle = PageTitle;
    PageTitle.setTitle(PageTitle.defaultTitle());

    _.extend($scope, atex.act.ViewUtils);

    ArtSynchronizationService.enableAutoSync();

    var onUnloadPromptFn = function() {
      var objects = $scope.articles.filter(function (article) {
        return (!article.local.persisted && !article.isBeingSent && !article.local.conflict);
      });

      if(objects.length > 0) {
        return "This action will discard your changes.";
      }
    };

    var onUnloadFn = function() {};
    $scope.templateList = [];
    UserProfileService.getConfigurationById({
      application:'act',
      id: 'templates-list'
    }).then(function(templatesListConfig) {
      if (templatesListConfig.templates && templatesListConfig.templates.templates.length > 0){
        $scope.templateList = templatesListConfig.templates.templates;
      }
    });

    $window.onbeforeunload = onUnloadPromptFn;
    $window.onunload = onUnloadFn;

    $scope.$on('$destroy', function () {
      ArtSynchronizationService.disableAutoSync();
    });

    $scope.$on('atex:synchronizationStart', function () {
      $scope.syncInProgress = true;
    });

    $scope.$on('atex:synchronizationEnd', function () {
      $scope.syncInProgress = false;
    });

    $translate(['EDIT', 'SEND', 'RESOLVE','REMOVE','CONFIRM_HEADER','DELETE_MSG','CANCEL_BTN','DEL_CONTENT_BTN', 'UNNAMED']).then(function (translations) {
        $scope.edit = translations.EDIT;
        $scope.send = translations.SEND;
        $scope.resolve = translations.RESOLVE;
        $scope.remove = translations.REMOVE;
        $scope.confirmHeader = translations.CONFIRM_HEADER;
        $scope.deleteMessage = translations.DELETE_MSG;
        $scope.cancelButton = translations.CANCEL_BTN;
        $scope.deleteContentButton = translations.DEL_CONTENT_BTN;
        $scope.unnamed = translations.UNNAMED;
    });

    $scope.$on('atex:contentSynchronized', function (event, updatedId, doRemove) {
      if (updatedId !== undefined) {
        var articles = $scope.articles.filter(function (article) {
          return article.meta.id === updatedId;
        });
        if (articles.length > 0) {
          if (doRemove) {
            $scope.articles = $scope.articles.filter(function (article) {
              return article.meta.id !== updatedId;
            });
          } else {
            var article = articles[0];
            ArtContentStore.getById(updatedId).then(function (storeArticle) {
              article.data = storeArticle.data;
              article.meta = storeArticle.meta;
              article.local = storeArticle.local;
            });
          }
        } else {
          if (!doRemove) {
            ArtContentStore.getById(updatedId).then(function (storeArticle) {
              $scope.articles.push(storeArticle);
            });
          }
        }
      } else {
        ArtContentStore.getAll().then(function (articles) {
          $scope.articles = articles;
        });
      }
    });

    $scope.synchronize = function() {
      ArtSynchronizationService.disableAutoSync();
      ArtSynchronizationService.synchronize(false);
      ArtSynchronizationService.enableAutoSync();
    };

    /**
     * TODO: isn't it safe to always wash a text through
     * JQuery (only if <p> found ATM)?
     */
    $scope.wash = function (text) {
      if (!text.match(/<p>/)) {
        return text;
      } else {
        return $(text).text();
      }
    };

    $scope.setDetectChanges = function() {
      return ApplicationConfigurationService.getConfigurationFor(['serverDataSynchronization', 'detectChanges'], true).then(function(detectChanges){
        return detectChanges;
      });
    };

    $scope.setDetectChanges().then(function(detectChanges) {
      $scope.detectChanges = detectChanges;
    });

    $scope.getItemDetails = function (content)
    {
      var template = getTemplateFor(content);

      return {
        article: content,
        template: template,
        hasTemplate: template !== undefined
      };
    };

    $scope.getTemplatesFor = function (itemDetails) {
      if (typeof itemDetails.template === 'undefined') {
        return [];
      }

      var suitableTemplates = _.filter(templates, function (template) {
        var templateInConfig = true;
        if ($scope.templateList.length > 0){
          templateInConfig = $scope.templateList.includes(template.id);
        }
        return template.type === itemDetails.template.type && getGroupType(template) !== undefined && templateInConfig;
      });

      return suitableTemplates;
    };

    var updateCleanAndDirtyArticles = function (articles) {
      var cleanArticles = [];
      var dirtyArticles = [];

      for (var i = 0; i < articles.length; i++) {
        var article = articles[i];
        (function (article, i) {
          ArtContentStore.setModifiedState(article).then( function (content) {
            articles[i].local.persisted = content.local.persisted;
            if (!article.local.persisted || article.isBeingSent || article.sendError || article.local.conflict) {
              dirtyArticles.push(article);
            } else {
              cleanArticles.push(article);
            }
          });
        })(article, i);
      }

      $scope.cleanArticles = cleanArticles;
      $scope.dirtyArticles = dirtyArticles;
    };

    updateCleanAndDirtyArticles(articles);

    var isGroupDefault = function( template ) {
       if ( (typeof template !== 'undefined') && (typeof template.group !== 'undefined') && (typeof template.group.default !== 'undefined') ) {
        return template.group.default !== 0;
      }

      return false;
    };

    var getTemplateFor = function (content) {
      /**
       * This is where we would try to find template information in the data itself.
       * Note that even if the data has template information in it, the template has
       * to exist in the template list for the tool (Contributor Tool).
       */

      var template = undefined;
      var createdWithTemplateId = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/atex.OneCMS/data/createdWithTemplate');

      if (typeof createdWithTemplateId !== 'undefined') {
        template = _.find(templates, function (template) {
          return template.id === createdWithTemplateId;
        });
      }

      /**
       * Regardless of whether or not there is creation template information in the
       * content data, we fallback to the first template (in our list) that operates
       * on the same content and group.
       */
      if (typeof template === 'undefined') {
        template = _.find(templates, function (template) {

          return isGroupDefault( template ) &&
              ( template.type !== 'undefined' ) &&
              ( template.type === content.data.aspects.contentData.data._type) &&
              ( !template.id.endsWith('.preview') && !template.id.endsWith('.readonly'));
        });
      }

      /**
       * Lastly we fallback to the first template (in our list) that operates
       * on the same content / data type.
       */
      if (typeof template === 'undefined') {
        template = _.find(templates, function (template) {
          return typeof template.type !== 'undefined' && template.type === content.data.aspects.contentData.data._type
            && (!template.id.endsWith('.preview') && !template.id.endsWith('.readonly'));
        });
      }

      return template;
    };

    var getGroupType = function( template ) {
      if (typeof template !== 'undefined' && typeof template.group !== 'undefined' && typeof template.group.type !== 'undefined' ) {
        return template.group.type;
      }

      return undefined;
    };

    $scope.hasTemplateFor = function (article) {
      return typeof getTemplateFor(article) !== 'undefined';
    };

    $scope.getDisplayTitle = function (itemDetails) {
      if (typeof itemDetails.template === 'undefined') {
        return itemDetails.article.meta.id;
      }

      var path = JSON.parse(JSON.stringify(itemDetails.template.namePath || ["name"]));
      var pathArray = atex.onecms.ObjectUtils.expandShortPath(path);
      var name = atex.onecms.ObjectUtils.getByPath(itemDetails.article.data.aspects, pathArray);

      if ( typeof name === 'undefined' ) {
        return constructListName(itemDetails);
      }

      return name.trim() || constructListName(itemDetails);
    };

    $scope.getHeadline = function (itemDetails) {
      var res = "";
      if (itemDetails.headline){
        res = itemDetails.headline.text.replace(/<\/?[^>]+(>|$)/g, "");
      }
      return res;
    };

    $scope.getStatus = function (itemDetails) {
      var res = "";
      if (itemDetails.aspects["atex.WFContentStatus"]){
        res = itemDetails.aspects["atex.WFContentStatus"].data.status.name;
      }
      return res;
    };

    $scope.getTitleLabel = function(article) {
      return $scope.getPrimaryAction(article).label;
    };

    var constructListName = function (itemDetails) {
      var label = getGroupType( itemDetails.template );

      if ( typeof label === 'undefined' ) {
        label = $scope.getTemplateLabel( itemDetails );
      }

      return $scope.unnamed + " " + label + " - id " + itemDetails.article.meta.id;
    };

    $scope.getTemplateLabel = function(itemDetails) {
      if (typeof itemDetails.template === 'undefined') {
        return "WARNING: NO TEMPLATE FOUND";
      }

      return itemDetails.template.label;
    };

    var isActId = function(potentialActId) {
      return typeof potentialActId === 'string' && potentialActId.indexOf('act:') === 0;
    };

    $scope.listFilter = function(value, index, array) {
         var itemDetails = $scope.getItemDetails(value);
         var isTemplateHidden = !itemDetails.hasTemplate || itemDetails.template.hidden;

      return !isActId(value.meta.id) && !isTemplateHidden && ($scope.listOptions.searchText === ''
        || $scope.getDisplayTitle($scope.getItemDetails(value)).search(new RegExp($scope.listOptions.searchText, 'i')) > -1);
    };

    $scope.sortPredicate = function(value) {
      switch ($scope.listOptions.sortField) {
        case 'title':
          return $scope.getDisplayTitle($scope.getItemDetails(value));
        case 'dateModified':
          return value.meta.modificationDate;
      }
    };

    $scope.sortBy = function(value) {
      if ($scope.listOptions.sortField === value) {
        $scope.listOptions.reverseSort = !$scope.listOptions.reverseSort;
      }
      else {
        $scope.listOptions.sortField = value;
        $scope.listOptions.reverseSort = (value === 'dateModified');
      }
    };

    $scope.id = function(text) {
      return text.replace(/[\.:]/g, '_');
    };

    $scope.editArticle = function(article) {
      if (!$scope.hasTemplateFor(article)) {
        console.log("WARNING: Content is not editable, will not edit...");
        return;
      }

      $location.path("/edit/" + article.meta.id);
      $location.search('fromList',1);
    };

    $scope.editArticleUsing = function(article, template) {
      $location.path("/editUsing/" + article.meta.id + "/" + template.id);
      $location.search('fromList',1);
    };

    $scope.getPrimaryAction = function(article) {
      var isConflict = article.local.conflict,
        isPersisted = article.local.persisted,
        isSendable = article.local.valid && !article.local.conflict;

      var actions = {
        'resolve': {
          "label": $scope.resolve,
          "icon": "fa-code-fork",

          "action": function() {
            $scope.requestConflictResolution(article);
          }
        },

        'send': {
          "label": $scope.send,
          "icon": "fa-upload",

          "action": function() {
            $scope.storeToServer(article);
          }
        },

        'edit': {
          "label": $scope.edit,
          "icon": "fa-pencil",

          "action": function() {
            $location.path("/edit/" + article.meta.id);
            $location.search('fromList',1);
          }
        },

        'remove': {
          "label": $scope.remove,
          "icon": "fa-trash-o",

          "action": function() {
            $scope.requestDestroy(article);
          }
        }
      };

      if (isConflict) {
        return actions.resolve;
      } else if (!isConflict && !isPersisted && isSendable) {
        return actions.send;
      } else if (!$scope.hasTemplateFor(article)) {
        return actions.remove;
      }

      return actions.edit;
    };

    $scope.performPrimaryAction = function(article) {
      $scope.getPrimaryAction(article).action();
    };

    $scope.getPrimaryLabel = function(article) {
      return $scope.getPrimaryAction(article).label;
    };

    $scope.getPrimaryIcon = function(article) {
      return $scope.getPrimaryAction(article).icon;
    };

    $scope.requestDestroy = function(article) {
      var confirmModal = ArtConfirmModal.create({
        'confirmHeader': $scope.confirmHeader,
        'confirmBody': $scope.deleteMessage,
        'cancel': $scope.cancelButton,
        'ok':  $scope.deleteContentButton,
        'mode': 'danger'
      });

      confirmModal.then(function(confirmed) {
        if (confirmed) {
          $scope.destroy(article);
        }
      });
    };

    $scope.requestConflictResolution = function(article, conflictList) {
      var conflictModal = ArtConflictModal.create({
        conflictObject: article.local.conflict,
        conflictList: conflictList,
        suppressCompare: true
      });

      ArtContentStore.addToSyncSkipList(article.meta.id);

      conflictModal.whenResolved().then(function(result) {
        if ( !$scope.detectChanges && result.resolution === 'ignored'){
          article.local.conflict = undefined;
          article.local.syncFailed = undefined;

          return ArtContentStore.put(article).then(function() {
            return conflictModal.destroy();
          });
        } else if (result.resolution === 'server') {
          return ArtContentStore.getById(article.meta.id, true, true).then(function() {
            return ArtContentStore.getAll();
          }).then(function(articles) {
            $scope.articles = articles;

            ArtContentStore.removeFromSyncSkipList(article.meta.id);
            return conflictModal.destroy();
          });
        } else if (result.resolution === 'local') {
          article.meta.revision = article.local.conflict.revision;
          article.local.conflict = undefined;
          article.local.syncFailed = undefined;

          return ArtContentStore.put(article).then(function() {
            return ArtContentStore.getAll();
          }).then(function(articles) {
            $scope.articles = articles;

            ArtContentStore.removeFromSyncSkipList(article.meta.id);
            return conflictModal.destroy();
          });
        }
      });
    };

    $scope.requestSendErrorDialog = function(article) {
      var errorDialog = ArtErrorModal.create({
        errorHeader: 'Send failed',
        errorMessage: 'This article could not be sent to the server.',
        errorDetails: article.sendError
      });
    };

    $scope.destroy = function(article) {
      ArtContentStore.remove(article.meta.id).then(function() {
        return ArtContentStore.getAll();
      }).then(function(result) {
        $scope.articles = result;
      }, function(error) {
        console.log('ERROR: Deleting content, ', error);
      });
    };

    $scope.isSendable = function(article) {
      return (article.local.valid && !article.local.conflict && !article.isBeingSent && typeof getTemplateFor(article) !== 'undefined');
    };

    $scope.unlockArticle = function(article) {
      if (article.local.existsOnServer && article.local.persisted) {
        ArtLockingService.unlock([article.meta.id]);
      }
    };

    $scope.storeToServer = function(article) {
      if (!$scope.isSendable(article)) {
        console.log("WARNING: Content is not sendable, will not send to server.");
        return;
      }

      delete article.sendError;
      delete article.sendCancelled;
      delete article.data.contentUpdated;

      article.isBeingSent = true;
      article.template = getTemplateFor(article);

      return ArtPrintData.flushPrintUpdates(article).then(function(article) {
        ArtContentStore.sendToServer(article).then(function () {
          delete article.isBeingSent;
          $scope.unlockArticle(article);

          return ArtContentStore.getAll();
        }).then(function (articles) {
          $scope.articles = articles;

          $scope.articles.forEach(function (articleItem) {
            if (article.meta.id === articleItem.meta.id) {

             if ( ArtInboxOptions.shouldShowInInbox( articleItem ) ) {
                articleItem.wasJustSaved = true;

                $timeout(function () {
                  articleItem.wasJustSaved = false;
                }, 2500);
              } else {
                $scope.destroy(article);
              }
            }
          });

          ArtCommonServices.unlockResources(article);
        }).then(null, function (error) {
          delete article.isBeingSent;

          if (error.type === atex.onecms.error.types.PERMISSION_DENIED) {
            $scope.destroy(article);
          } else if (error.type === atex.onecms.error.types.OPERATION_CANCELLED) {
            article.sendCancelled = true;
          } else if (!$scope.detectChanges && error.type === atex.onecms.error.types.CONFLICT) {
            $scope.requestConflictResolution(article, JSON.parse(error.rootCause.response.extraInfo.conflicts));
          } else {
            if (!article.local.conflict) {
              article.sendError = "Unknown error sending article.";

              if (error.rootCause && error.rootCause.response && error.rootCause.response.message) {
                article.sendError = error.rootCause.response.message + ".";
              }
            }
          }
        });
      },function(response) {
        console.log("WARNING: Error sending content to print server. Response = ", response);

        delete article.isBeingSent;
        article.sendError = "Unknown error sending print content to layout server.";

      });
    };

  }
]);

/**
 * TODO: This resolve should probably be a factory.
 */
var ContentListController = {
  resolves : {
    'preload-factory' : function(PreloadService) {
      return PreloadService.preloadFactoryList('actList');
    },
    'articles': function(ArtContentStore, ArtSynchronizationService) {
      return ArtSynchronizationService.whenSynchronized({ all: true }).then(function() {
        return ArtContentStore.getAll();
      });
    },

    'templates': function(ArtTemplateStore) {
      return ArtTemplateStore.getAll();
    }
  }
};
